export const GET_SUBSCRIPTION_ACTIONS = {
    GET_SUBSCRIPTION_REQUEST: "GET_SUBSCRIPTION_REQUEST",
    GET_SUBSCRIPTION_RESPONSE: "GET_SUBSCRIPTION_RESPONSE",
    GET_SUBSCRIPTION_ERROR: "GET_SUBSCRIPTION_ERROR",
};

// Admin
  export const ADMIN_SUBSCRIPTION_ACTIONS = {
    // list
    SUBSCRIPTION_LIST_REQUEST: "ADMIN_SUBSCRIPTION_LIST_REQUEST",
    SUBSCRIPTION_LIST_RESPONSE: "ADMIN_SUBSCRIPTION_LIST_RESPONSE",
    SUBSCRIPTION_LIST_ERROR: "ADMIN_SUBSCRIPTION_LIST_ERROR",

    // create
    SUBSCRIPTION_REQUEST: "SUBSCRIPTION_REQUEST",
    SUBSCRIPTION_RESPONSE: "SUBSCRIPTION_RESPONSE",
    SUBSCRIPTION_ERROR: "SUBSCRIPTION_ERROR",

    // update
    SUBSCRIPTION_EDIT_REQUEST: "SUBSCRIPTION_EDIT_REQUEST",
    SUBSCRIPTION_EDIT_RESPONSE: "SUBSCRIPTION_EDIT_RESPONSE",
    SUBSCRIPTION_EDIT_ERROR: "SUBSCRIPTION_EDIT_ERROR",

    // delete
    SUBSCRIPTION_DELETE_REQUEST: "SUBSCRIPTION_DELETE_REQUEST",
    SUBSCRIPTION_DELETE_RESPONSE: "SUBSCRIPTION_DELETE_RESPONSE",
    SUBSCRIPTION_DELETE_ERROR: "SUBSCRIPTION_DELETE_ERROR",
  };
  
